import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { useDispatch, useSelector } from "react-redux";
import {
  CODOrder,
  getOrderDetails,
  payOrder,
} from "../Redux/Actions/OrderActions";
import Loading from "../components/LoadingError/Loading";
import Message from "../components/LoadingError/Error";
import moment from "moment";
import { ORDER_PAY_RESET } from "../Redux/Constants/OrderConstants";
import {
  BASE_URL,
  DEFAULT_CURRENCY,
  IMAGE_CACHE_URL,
} from "../Redux/Constants/GlobalConstant";
import MobileNav from "../components/MobileNav";
import axios from "axios";
import {
  DEFAULT_COD_BUTTON_LABEL,
  DEFAULT_STRIPE_BUTTON_LABEL,
} from "../config/Constant";
import BestDealSection from "../components/homeComponents/BestDealSection";

const OrderScreen = ({ match }) => {
  const dispatch = useDispatch();
  const orderId = match.params.id;

  const [sdkReady, setSdkReady] = useState(false);
  const [codLoading] = useState(false);

  const orderDetails = useSelector((state) => state.orderDetails);
  const { order, loading, error } = orderDetails;

  const orderPay = useSelector((state) => state.orderPay);
  const { success: successPay } = orderPay;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  /* ---------- FIX: scroll only once ---------- */
  useEffect(() => {
    window.scrollTo({
      top: window.innerHeight / 2,
      behavior: "smooth",
    });
  }, []);

  /* ---------- FIX: fetch order correctly ---------- */
  useEffect(() => {
    if (!order || order._id !== orderId || successPay) {
      dispatch({ type: ORDER_PAY_RESET });
      dispatch(getOrderDetails(orderId));
    }
  }, [dispatch, orderId, successPay, order]);

  /* ---------- FIX: Stripe button ready ---------- */
  useEffect(() => {
    if (order && !order.isPaid) {
      setSdkReady(true);
    }
  }, [order]);

  /* ---------- FIX: DO NOT MUTATE order ---------- */
  const itemsPrice =
    !loading && order?.orderItems
      ? order.orderItems
          .reduce((acc, item) => acc + item.price * item.qty, 0)
          .toFixed(2)
      : "0.00";

  const itemsMrpPrice =
    !loading && order?.orderItems
      ? order.orderItems
          .reduce((acc, item) => acc + item.mrp_price * item.qty, 0)
          .toFixed(2)
      : "0.00";

  /* ---------- FIX: COD ---------- */
  const successCODHandler = () => {
    dispatch(CODOrder(orderId));
  };

  /* ---------- FIX: Stripe ---------- */
  const successStripeHandler = async () => {
    try {
      setSdkReady(false);
      const stripeItems = order.orderItems.map((item) => ({
        name: item.name,
        price: Number(item.price),
        qty: Number(item.qty),
      }));

      const { data } = await axios.post(
        `${BASE_URL}/api/stripe/create-checkout-session`,
        {
          items: stripeItems,
          customer_email: userInfo?.email || "aarohfood@gmail.com",
          order_id: order._id,
          success_url: `${window.location.origin}/order/${order._id}`,
          cancel_url: `${window.location.origin}/order/${order._id}`,
          discount: Number(order.couponDiscount || 0),
          shipping_fee: Number(order.shippingPrice),
        },
        { headers: { "Content-Type": "application/json" } },
      );

      window.location.href = data.url;
      setSdkReady(true);
    } catch (error) {
      console.error(
        "Stripe checkout error:",
        error.response?.data || error.message,
      );
      alert("Unable to start Stripe checkout");
      setSdkReady(true);
    }
  };

  /* ---------- FIX: Stripe verify (safe) ---------- */
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const sessionId = query.get("session_id");
    if (!sessionId) return;

    const verifyPayment = async () => {
      try {
        const { data } = await axios.get(
          `${BASE_URL}/api/stripe/verify/${sessionId}`,
        );

        if (data.payment_status === "paid") {
          dispatch(
            payOrder(orderId, {
              id: data.payment_intent,
              status: data.payment_status,
              email_address: userInfo.email,
              update_time: Date.now(),
            }),
          );

          window.history.replaceState({}, "", `/order/${orderId}`);
        }
      } catch (err) {
        console.error("Stripe verification failed:", err);
      }
    };

    verifyPayment();
  }, [dispatch, orderId, userInfo.email]);

  // useEffect(() => {
  //   if (sdkReady) {
  //     const timer = setTimeout(() => {
  //       document.getElementById("stripe-button").click();
  //     }, 1000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [sdkReady]);
  /* ======================= UI BELOW IS UNCHANGED ======================= */

  return (
    <>
      <Header />
      <MobileNav />
      <div className="container">
        {loading ? (
          <Loading />
        ) : error ? (
          <Message variant="alert-danger">{error}</Message>
        ) : (
          <>
            {order.reward_value > 0 && order.isPaid && (
              <div className="">
                Congratulation, {DEFAULT_CURRENCY} <b>{order.reward_value} </b>{" "}
                Cash Point will be added to your Account after Delivery.
              </div>
            )}
            {order.reward_value > 0 && order.isCOD && (
              <div className="">
                Congratulation, {DEFAULT_CURRENCY} <b>{order.reward_value} </b>{" "}
                Cash Point will be added to your Account after Delivery.
              </div>
            )}

            <div className="row  order-detail desktop-cart-view">
              <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
                <div className="row ">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-user"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Customer</strong>
                    </h5>
                    <p>{order.user.name}</p>
                    <p>
                      <a href={`mailto:${order.user.email}`}>
                        {order.user.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              {/* 2 */}
              <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
                <div className="row">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-truck-moving"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Order info</strong>
                    </h5>
                    <p>
                      <strong>Shipping:</strong> {order.shippingAddress.city}
                    </p>
                    <p>
                      <strong>Pay method: </strong>
                      {order.paymentMethod}
                    </p>

                    {order.isPaid && !order.isDelivered && (
                      <div className="bg-info p-2 col-12">
                        <p className="text-white text-center text-sm-start">
                          Paid on {moment(order.paidAt).calendar()}
                        </p>
                      </div>
                    )}
                    {order.isCOD && !order.isDelivered && (
                      <div className="bg-info p-2 col-12">
                        <p className="text-white text-center text-sm-start">
                          Confirmed, Cash on Delivery
                        </p>
                      </div>
                    )}
                    {order.isDelivered && (
                      <div className="bg-info p-2 col-12">
                        <p className="text-white text-center text-sm-start">
                          Delivered
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* 3 */}
              <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
                <div className="row">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Deliver to</strong>
                    </h5>
                    <p>
                      Address: {order.shippingAddress.city},{" "}
                      {order.shippingAddress.address},{" "}
                      {order.shippingAddress.postalCode}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row  order-detail mobile-cart-view">
              <div className="col-lg-4 col-sm-4 mb-lg-0 mb-0 mb-sm-0">
                <div className="row">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-truck-moving"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Order info</strong>
                    </h5>
                    <p>
                      <strong>Shipping: </strong>
                      {order.shippingAddress.city}
                    </p>
                    <p>
                      <strong>Pay Method: </strong>{" "}
                      {order?.paymentMethod ? order.paymentMethod : "UPI"}
                    </p>

                    {order.isPaid && (
                      <div className="bg-info p-2 col-12">
                        <p className="text-white text-center text-sm-start">
                          Paid on {moment(order.paidAt).calendar()}
                        </p>
                      </div>
                    )}
                    {order.isCOD && (
                      <div className="bg-info p-2 col-12">
                        <p className="text-white text-center text-sm-start">
                          Cash on Delivery
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="row order-products justify-content-between">
              <div className="col-lg-8">
                {order.orderItems.length === 0 ? (
                  <Message variant="alert-info mt-5">
                    Your order is empty
                  </Message>
                ) : (
                  <>
                    {order.orderItems.map((item, index) => (
                      <div key={index}>
                        <div
                          className="order-product row desktop-cart-view"
                          key={index}
                        >
                          <div className="col-md-3 col-6">
                            <img
                              src={IMAGE_CACHE_URL + item.image}
                              alt={item.name}
                            />
                          </div>
                          <div className="col-md-5 col-6 d-flex align-items-center">
                            <Link to={`/products/${item.product}`}>
                              <h6>{item.name}</h6>
                            </Link>
                          </div>
                          <div className="mt-3 mt-md-0 col-md-2 col-6  d-flex align-items-center flex-column justify-content-center ">
                            <h4>QUANTITY</h4>
                            <h6>{item.qty}</h6>
                          </div>
                          <div className="mt-3 mt-md-0 col-md-2 col-6 align-items-end  d-flex flex-column justify-content-center ">
                            <h4>SUBTOTAL</h4>
                            <h6>
                              {DEFAULT_CURRENCY}{" "}
                              {(item.qty * item.price).toFixed(2)}
                            </h6>
                          </div>
                        </div>
                        <div
                          className="order-product row mobile-cart-view"
                          key={index + 1}
                        >
                          <div className="cart-image-name-together">
                            <img
                              src={IMAGE_CACHE_URL + item.image}
                              alt={item.name}
                            />
                            <Link to={`/products/${item.product}`}>
                              <h4>{item.name}</h4>
                            </Link>
                          </div>
                          <div className="cart-price cart-price-total">
                            <h4>QUANTITY</h4>
                            <h6 className="po-item-qty">{item.qty}</h6>
                          </div>
                          <div className="cart-price cart-price-total">
                            <h4>SUBTOTAL</h4>
                            <h6 className="po-item-qty">
                              {DEFAULT_CURRENCY} {item.qty * item.price}
                            </h6>
                          </div>
                        </div>
                      </div>
                    ))}
                    {order?.userNotes && (
                      <div className="col-lg-6">
                        <div className="form-label">
                          <strong>Order Notes: </strong>
                          {order?.userNotes}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* total */}
              <div className="col-lg-3 d-flex align-items-end flex-column mt-5 subtotal-order">
                <table className="table table-bordered">
                  <tbody>
                    {itemsMrpPrice !== itemsPrice && (
                      <tr>
                        <td>
                          <strong>Total MRP</strong>
                        </td>
                        <td className="text-align-right">
                          {DEFAULT_CURRENCY}{" "}
                          {parseFloat(itemsMrpPrice).toFixed(2)}
                        </td>
                      </tr>
                    )}
                    {itemsMrpPrice !== itemsPrice && (
                      <tr>
                        <td>
                          <strong>Total Saving</strong>
                        </td>
                        <td className="text-align-right">
                          {DEFAULT_CURRENCY}{" "}
                          {parseFloat(itemsMrpPrice - itemsPrice).toFixed(2)}
                        </td>
                      </tr>
                    )}
                    {order.couponDiscount > 0 && (
                      <tr>
                        <td>
                          <strong>Coupon Saving</strong>
                        </td>
                        <td className="text-align-right">
                          {DEFAULT_CURRENCY}{" "}
                          {parseFloat(order.couponDiscount).toFixed(2)}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td>
                        <strong>Our Price</strong>
                      </td>
                      <td className="text-align-right">
                        {DEFAULT_CURRENCY}{" "}
                        {parseFloat(order.totalPrice).toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Shipping</strong>
                      </td>
                      <td className="text-align-right">
                        {DEFAULT_CURRENCY} {order.shippingPrice}
                      </td>
                    </tr>
                    {/* <tr>
                      <td>
                        <strong>Tax</strong>
                      </td>
                      <td className="text-align-right">
                        {order.taxPrice <= 0
                          ? "Included"
                          : { DEFAULT_CURRENCY } + " " + order.taxPrice}
                      </td>
                    </tr> */}
                    <tr>
                      <td colSpan={2}></td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total</strong>
                      </td>
                      <td className="text-align-right">
                        {DEFAULT_CURRENCY}{" "}
                        <b>
                          {(
                            parseFloat(order.totalPrice) +
                            parseFloat(order.shippingPrice)
                          ).toFixed(2)}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
                {/* Stripe Button  */}
                {!order.isPaid &&
                  !order.isCOD &&
                  (order.paymentMethod === "stripe" ||
                    order.paymentMethod === "cnc") && (
                    <div className="col-12">
                      {!sdkReady ? (
                        <Loading />
                      ) : (
                        <button
                          onClick={successStripeHandler}
                          className="round-black-btn"
                          id="stripe-button"
                        >
                          {DEFAULT_STRIPE_BUTTON_LABEL}
                        </button>
                      )}
                    </div>
                  )}
                {/* COD Button */}
                {!order.isCOD &&
                  !order.isPaid &&
                  order.paymentMethod === "COD" && (
                    <div className="col-12">
                      {codLoading && <Loading />}
                      {!codLoading && (
                        <button
                          onClick={successCODHandler}
                          className="round-black-btn"
                        >
                          {DEFAULT_COD_BUTTON_LABEL}
                        </button>
                      )}
                    </div>
                  )}
              </div>
            </div>

            <div className="row  order-detail order-mobile-cart-view">
              <div className="col-lg-4 col-sm-4 mb-lg-0 mb-5 mb-sm-0">
                <div className="row ">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-user"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Customer</strong>
                    </h5>
                    <p>{order.user.name}</p>
                    <p>
                      <a href={`mailto:${order.user.email}`}>
                        {order.user.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              {/* 3 */}
              <div className="col-lg-4 col-sm-4 mb-lg-0 mb-5 mb-sm-0">
                <div className="row">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Deliver to</strong>
                    </h5>
                    <p>
                      Address: {order.shippingAddress.city},{" "}
                      {order.shippingAddress.address},{" "}
                      {order.shippingAddress.postalCode}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <BestDealSection />
      </div>
    </>
  );
};

export default OrderScreen;
